import { Link as RouterLink } from 'react-router-dom'
import { Link } from '@mui/material'
import Logo from '../../../components/Logo'
import { DASHBOARD_PATH } from '../../../config'

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => (
  <Link component={RouterLink} to={DASHBOARD_PATH} aria-label="theme-logo">
    <Logo />
  </Link>
)

export default LogoSection
